import { SectionHandler } from '../entity.handler';
import { AdminEditorService } from '../../admin.service';
import { EventEmitter } from '@angular/core';
import { MediaInfoResponse } from '@key-telematics/fleet-api-client';

export interface MediaSectionValues {
    filename: string;
}



export class MediaSectionHandler implements SectionHandler<MediaInfoResponse, MediaSectionValues> {

    type = 'media';
    icon = '';
    bulk: false;
    description = '';
    title: '';

    onSettingsChanged = new EventEmitter<void>();

    constructor(
        public admin: AdminEditorService
    ) {
    }

    applyUpdate(_entity: any, _payload: any): Promise<any> {
        return Promise.reject(new Error('applyUpdate not supported'));
    }

    async mapEntityToEditor(entity: MediaInfoResponse): Promise<MediaSectionValues> {
        return {
            filename: entity.status === 'ready' ? entity.filename : null,
        };
    }

    mapEditorToEntity(_entity: any, _values: MediaSectionValues): Promise<any> {
        return Promise.reject(new Error('mapEditorToEntity not supported'));
    }



}

